import React from "react";
import { Mail, Phone, MapPin, Facebook, Instagram, Youtube, Linkedin, Twitter } from "lucide-react";
import { useSettings } from "../settings";

const Footer = () => {
  const { settings } = useSettings();
  const s = settings.socials || {};

  return (
    <footer className="bg-white border-t border-neutral-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-6 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-5 text-sm text-neutral-600">
        {/* Contact info — first on mobile, middle on desktop */}
        <div className="order-1 lg:order-2 flex flex-wrap justify-center lg:justify-center items-center gap-4 md:gap-5">
          <a href={`mailto:${settings.email}`} className="hover:text-[#C9A24B] transition-colors inline-flex items-center gap-1.5" aria-label="E-posta">
            <Mail className="w-4 h-4" />
            <span className="text-xs">{settings.email}</span>
          </a>
          <a href={`tel:${(settings.phone || "").replace(/\s+/g, "")}`} className="hover:text-[#C9A24B] transition-colors inline-flex items-center gap-1.5" aria-label="Telefon">
            <Phone className="w-4 h-4" />
            <span className="text-xs">{settings.phone}</span>
          </a>
          <span className="inline-flex items-center gap-1.5 text-neutral-600">
            <MapPin className="w-4 h-4" />
            <span className="text-xs">{settings.address}</span>
          </span>
        </div>

        {/* Socials — second on mobile, right on desktop */}
        <div className="order-2 lg:order-3 flex items-center justify-center gap-4">
          {s.facebook && (
            <a href={s.facebook} target="_blank" rel="noreferrer" className="hover:text-[#C9A24B] transition-colors" aria-label="Facebook">
              <Facebook className="w-4 h-4" />
            </a>
          )}
          {s.instagram && (
            <a href={s.instagram} target="_blank" rel="noreferrer" className="hover:text-[#C9A24B] transition-colors" aria-label="Instagram">
              <Instagram className="w-4 h-4" />
            </a>
          )}
          {s.youtube && (
            <a href={s.youtube} target="_blank" rel="noreferrer" className="hover:text-[#C9A24B] transition-colors" aria-label="YouTube">
              <Youtube className="w-4 h-4" />
            </a>
          )}
          {s.linkedin && (
            <a href={s.linkedin} target="_blank" rel="noreferrer" className="hover:text-[#C9A24B] transition-colors" aria-label="LinkedIn">
              <Linkedin className="w-4 h-4" />
            </a>
          )}
          {s.twitter && (
            <a href={s.twitter} target="_blank" rel="noreferrer" className="hover:text-[#C9A24B] transition-colors" aria-label="Twitter">
              <Twitter className="w-4 h-4" />
            </a>
          )}
        </div>

        {/* Copyright — LAST on mobile/tablet (centered), FIRST on desktop (left) */}
        <div className="order-3 lg:order-1 text-center lg:text-left text-xs text-neutral-500 lg:text-neutral-600 lg:text-sm">
          © {new Date().getFullYear()} {settings.legal_name}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
